export const SETTLEMENT_REQUESTS_RESET_STATE = 'SETTLEMENT_REQUESTS_RESET_STATE';
export const SETTLEMENT_REQUESTS_CURRENT_ITEM = 'SETTLEMENT_REQUESTS_CURRENT_ITEM';

export const SETTLEMENT_REQUESTS_REQUEST_LOADING = 'SETTLEMENT_REQUESTS_REQUEST_LOADING';
export const SETTLEMENT_REQUESTS_REQUEST_SUCCESS = 'SETTLEMENT_REQUESTS_REQUEST_SUCCESS';
export const SETTLEMENT_REQUESTS_REQUEST_FAILED = 'SETTLEMENT_REQUESTS_REQUEST_FAILED';

export const SETTLEMENT_REQUESTS_CURRENT_ACTION = 'SETTLEMENT_REQUESTS_CURRENT_ACTION';
export const SETTLEMENT_REQUESTS_RESET_ACTION = 'SETTLEMENT_REQUESTS_RESET_ACTION';